import { Component, OnInit } from '@angular/core';
import { BodegaService } from '../../services/bodega.service';
import { Bodega } from '../../model/bodega';

import { UtilitiesService } from '../../services/utilities.service';

@Component({
  selector: 'app-bodega-list',
  templateUrl: './bodega-list.component.html',
  styleUrls: ['./bodega-list.component.css']
})
export class BodegaListComponent implements OnInit {

  public bodegaSeleccionada: Bodega;

  public modoEdicion: boolean = false;
  public bodegas: Bodega[];
public filtro:string;
  constructor(
    private bodegaService: BodegaService,
    private _utilities: UtilitiesService

  ) {

  }

  ngOnInit() {
    
    this.filtro = "";
    this.bodegas = [];
    if (sessionStorage.getItem("login") === null) {
      window.location.href = "/";
    }
    this.refrescarBodegas();
  }

  refrescarBodegas() {
    this.bodegaService.getBodegas()
      .subscribe(
      data => this.bodegas = data,
      err => {
        console.log(err);
      });
  }


  editarRegistro(_bodega: Bodega) {
    //_consorcio.vigenciaContrato = new Date(_consorcio.vigenciaContrato.getFullYear(), _consorcio.vigenciaContrato.getMonth() + 1, _consorcio.vigenciaContrato.getDate());
    this.bodegaSeleccionada = _bodega;
    this.modoEdicion = true;
  }


  agregarRegistro() {
    this.bodegaSeleccionada = null;
    this.modoEdicion = true;
  }


  regresar() {
    this.refrescarBodegas();
    this.modoEdicion = false;
  }


}



// WEBPACK FOOTER //
// D:/Proyectos/tpl viejo prueba/eflowTPL/src/app/components/bodega-list/bodega-list.component.ts